/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fertilizer_InstructionsInputs */

const vi_fertilizer_instructions = /** @type {(inputs: Fertilizer_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hướng dẫn sử dụng`)
};

/**

* @param {Fertilizer_InstructionsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fertilizer_instructions = /** @type {((inputs?: Fertilizer_InstructionsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fertilizer_InstructionsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fertilizer_instructions(inputs)
});